import { GeoDsMeta } from './meta-data.model';

export class GeoDsDocument extends GeoDsMeta {
  ParentId: string;
  Designation: string;
  FileName: string;
  Kind: DocumentKind;
  InsertDate: string;
  Object: string;
  ParentObjectType: string;
  IdRefPersonInsert: string;
  Reserve1: string;
  Reserve2: string;
  Reserve3: string;
  Reserve4: string;
  Reserve5: string;
  DateEnd: string;
  Comment: string;
  constructor(data: GeoDsDocument) {
    super();
    Object.assign(this, data);
  }
}

export enum DocumentKind {
  Dokument = 'DOC',
  ELOLink = 'ELO-Link',
  Datei = 'FILE',
  Bild = 'IMAGE',
  PFAD = 'PATH',
  Video = 'VIDEO',
}
